import type { WebRtcConnectionStep } from "@riq/webrtc";

/** Shared Indonesian UI strings for @riq/ui. */
export const uiCopy = {
  navAriaLabel: "Navigasi utama",
  connectionProgressAria: "Progres koneksi",
} as const;

export const feedbackCopy = {
  ariaLabel: "Kirim masukan",
  title: "Masukan",
  kindIssue: "Masalah",
  kindSuggestion: "Saran",
  messagePlaceholder: "Ceritakan masalah atau saran Anda…",
  submit: "Kirim",
  cancel: "Batal",
  sending: "Mengirim…",
  thanks: "Terima kasih! Masukan Anda sudah kami terima.",
  error: "Gagal mengirim. Coba lagi.",
} as const;

export const pwaUpdateCopy = {
  updateAvailable: "Versi baru tersedia.",
  update: "Perbarui",
  updating: "Memperbarui…",
  updateLater: "Nanti",
} as const;

export const pwaInstallCopy = {
  install: "Pasang aplikasi",
  installing: "Memasang…",
  iosHint: 'Ketuk Share lalu "Add to Home Screen" untuk memasang aplikasi.',
  dismiss: "Nanti",
} as const;

export const CONNECTION_INGEST_LABELS: Record<WebRtcConnectionStep, string> = {
  mic: "Mengakses mikrofon…",
  peer: "Memulai koneksi siaran…",
  offer: "Menyiapkan aliran audio…",
  session: "Menghubungkan ke server…",
  publish: "Mempublikasikan audio Anda…",
  subscribe: "Mempublikasikan audio Anda…",
  renegotiate: "Menyelesaikan aliran…",
  register: "Menyiapkan siaran langsung…",
  stream: "Menyambungkan media…",
  connected: "Live — audio mengalir",
};

export const CONNECTION_EGRESS_LABELS: Record<WebRtcConnectionStep, string> = {
  mic: "Menghubungkan…",
  peer: "Memulai koneksi Listener…",
  offer: "Menyiapkan pemutaran…",
  session: "Menghubungkan ke server…",
  publish: "Bergabung ke siaran…",
  subscribe: "Bergabung ke siaran langsung…",
  renegotiate: "Menyinkronkan audio…",
  register: "Bergabung ke siaran langsung…",
  stream: "Menerima audio…",
  connected: "Terhubung — audio dimulai",
};
